import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AssetManager from "../common/AssetManager";
import { Context as WikiContext } from "../context/wikiContext/WikiContext";
import AgeLocationSelect from "./FormSections/AgeLocationSelect";
import FormSectionContainer from "./FormSections/FormSectionContainer";
import SuggestionsContainer from "./FormSections/SuggestionsContainer";
import TemperatureSelect from "./FormSections/TemperatureSelect";
import "./formContainer.scss";

const FormContainer = () => {
  const { loadWikis } = useContext(WikiContext);
  const { i18n } = useTranslation();

  useEffect(() => {
    loadWikis();
  }, []);

  return (
    <div className="container form-container">
      <a href="https://kengurugold.com/">
        <img
          src={AssetManager.getAsset("/kenguru_logo.png")}
          alt="kengurugold-logo"
          className="kenguru-logo"
        />
      </a>

      <div className="main-details">
        <h2 className="title">{i18n.t("web_title")}</h2>
        <p className="description">{i18n.t("web_description")}</p>
      </div>
      <div className="form-sections-container">
        <FormSectionContainer index={1}>
          <AgeLocationSelect></AgeLocationSelect>
        </FormSectionContainer>
        <FormSectionContainer index={2}>
          <TemperatureSelect></TemperatureSelect>
        </FormSectionContainer>
        <FormSectionContainer index={3}>
          <SuggestionsContainer></SuggestionsContainer>
        </FormSectionContainer>
      </div>
    </div>
  );
};

export default FormContainer;
